import React from "react";
import { Form, Input, Radio } from "antd";

const NavigatorForm = () => {
  return (
    <Form
      name="complex-form"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 20 }}
    >
      <Form.Item label="起点">
        <Input.Group compact>
          <Form.Item
            name={["address", "province"]}
            noStyle
            rules={[{ required: true, message: "Province is required" }]}
          >
            <Input style={{ width: "50%" }} placeholder="经度" />
          </Form.Item>
          <Form.Item
            name={["address", "street"]}
            noStyle
            rules={[{ required: true, message: "Street is required" }]}
          >
            <Input style={{ width: "50%" }} placeholder="纬度" />
          </Form.Item>
        </Input.Group>
      </Form.Item>
      <Form.Item label="终点">
        <Input.Group compact>
          <Form.Item
            name={["address", "province"]}
            noStyle
            rules={[{ required: true, message: "Province is required" }]}
          >
            <Input style={{ width: "50%" }} placeholder="经度" />
          </Form.Item>
          <Form.Item
            name={["address", "street"]}
            noStyle
            rules={[{ required: true, message: "Street is required" }]}
          >
            <Input style={{ width: "50%" }} placeholder="纬度" />
          </Form.Item>
        </Input.Group>
      </Form.Item>
      <Form.Item name="radio-button" label="情景" rules={[]}>
        <Radio.Group>
          <Radio.Button value="a">情景一</Radio.Button>
          <Radio.Button value="b">情景二</Radio.Button>
          <Radio.Button value="c">情景三</Radio.Button>
        </Radio.Group>
      </Form.Item>
      <Form.Item name="radio-button" label="船舶" rules={[]}>
        <Radio.Group>
          <Radio.Button value="a">破冰船</Radio.Button>
          <Radio.Button value="b">货运船</Radio.Button>
        </Radio.Group>
      </Form.Item>
    </Form>
  );
};

export default NavigatorForm;
